import { AuxiliumComponent } from "../auxilium-component";

export default class FormSection extends AuxiliumComponent {
	static observable = ["heading", "description"];

	parsedCallback() {
		this.appendChild(document.createElementWithContents("div", this.childNodes, { className: "form-group__column-fields" }));

		const descriptionColumn = document.createElementWithContents("div",
			document.createElementWithContents("div", this.description, { className: "form-group__section-description" }), { className: "form-group__column-description" });

		if (this.heading) {
			descriptionColumn.prepend(document.createElementWithContents("chip-header", this.heading, { size: "4" }));
		}

		this.prepend(descriptionColumn);
	}
}
